import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'showExpiredCoupons',
  initialState: false,
  reducers: {
    setShowExpiredCoupons(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setShowExpiredCoupons } = slice.actions;

export default slice.reducer;
